import { Chip, styled, TextField } from '@mui/material';

interface AutoCompleteInputProps {
  isMobile: boolean;
  errorMessage?: string;
  disabled?: boolean;
}

const BORDER_DEFAULT = '#0000003A';
const BORDER_HOVER = '#000000DE';
const DARK_GREY = '#f4f5f6';
const DARK_ORANGE = '#ff8000';

export const AutoCompleteInput = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'isMobile' && prop !== 'errorMessage',
})((props: AutoCompleteInputProps & { disabled?: boolean }) => {
  const baseInputStyles = {
    borderColor: props.errorMessage ? DARK_ORANGE : BORDER_DEFAULT,
    borderWidth: props.errorMessage ? '2px' : '1px',
  };
  const disabledInputStyles = {
    borderColor: BORDER_DEFAULT,
    borderWidth: '1px',
  };
  const hoverInputStyles = {
    borderColor: props.errorMessage ? DARK_ORANGE : BORDER_HOVER,
    borderWidth: props.errorMessage ? '2px' : '1px',
  };

  return {
    '& .MuiOutlinedInput-root': {
      height: props.isMobile ? '50px' : '60px',
      ...(props.disabled && {
        background: DARK_GREY,
        color: BORDER_DEFAULT,
        pointerEvents: 'none',
      }),
      '& .MuiOutlinedInput-notchedOutline': props.disabled ? disabledInputStyles : baseInputStyles,
      '&:hover .MuiOutlinedInput-notchedOutline': props.disabled ? disabledInputStyles : hoverInputStyles,
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': props.disabled ? disabledInputStyles : hoverInputStyles,
      '& .MuiAutocomplete-popupIndicator': {
        marginRight: '4px',
      },
    },
  };
});

export const AutoCompleteLabel = styled(Chip)(() => ({
  backgroundColor: DARK_GREY,
  borderRadius: '4px',
  fontWeight: '500',
  fontSize: '16px',
}));
